import React from 'react';
import ReactFlow, {Background} from 'reactflow';

import {useEntityMapActorRef, useEntityMapSelector} from './EntityMapMachineProvider';
import EntityNode from './EntityNode';

const ENTITY_MAP_NODE_TYPES = {
  entity: EntityNode,
};

/**
 * Renders a view of the entity map for a given entityId
 */
export default function EntityMapView(): JSX.Element {
  const graphNodesById = useEntityMapSelector((s) => s.context.graphNodesById);
  const graphEdgesById = useEntityMapSelector((s) => s.context.graphEdgesById);
  const actorRef = useEntityMapActorRef();

  const graphNodes = Array.from(graphNodesById.values());
  const graphEdges = Array.from(graphEdgesById.values());

  return (
    <ReactFlow
      nodes={graphNodes}
      edges={graphEdges}
      nodeTypes={ENTITY_MAP_NODE_TYPES}
      fitView={true}
      onNodesChange={(changes) => {
        actorRef.send({type: 'onNodesChange', changes});
      }}
      onEdgesChange={(changes) => {
        actorRef.send({type: 'onEdgesChange', changes});
      }}
    >
      <Background />
    </ReactFlow>
  );
}
